import { createFileRoute } from '@tanstack/react-router'
import { AutoMLCatalogPage } from 'pages/kestrel/AutoMLCatalogPage'

export const Route = createFileRoute('/kestrel/automl-models')({
  component: AutoMLCatalogPage,
  staticData: {
    title: 'AutoML models',
  },
})
